module.exports = __webpack_public_path__ + "975e302918b453fb7c13f08d92a02be6.svg";